module.exports = __webpack_public_path__ + "img/brown-cat.80ef6020.png";